import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "leaderboard-list" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-10 text-muted"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center py-10 text-danger"
}
const _hoisted_4 = {
  key: 2,
  class: "text-center py-10 text-muted"
}
const _hoisted_5 = {
  key: 0,
  class: "leaderboard-podium"
}
const _hoisted_6 = { class: "leaderboard-podium__hero" }
const _hoisted_7 = { class: "leaderboard-podium__avatar-wrap" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "leaderboard-podium__wreath leaderboard-podium__wreath--left" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "leaderboard-podium__wreath leaderboard-podium__wreath--right" }, null, -1)
const _hoisted_10 = { class: "leaderboard-podium__name" }
const _hoisted_11 = { class: "leaderboard-podium__pedestal" }
const _hoisted_12 = { class: "leaderboard-podium__rank" }
const _hoisted_13 = {
  key: 1,
  class: "leaderboard-list__items"
}
const _hoisted_14 = { class: "leaderboard-list__rank" }
const _hoisted_15 = { class: "leaderboard-list__profile" }
const _hoisted_16 = { class: "leaderboard-list__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, " Loading leaderboard... "))
      : (_ctx.error)
        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
        : (_ctx.sortedRows.length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_4, " No results for this date range. "))
          : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
              (_ctx.podiumEntries.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.podiumEntries, (entry) => {
                      return (_openBlock(), _createBlock("div", {
                        key: entry.rank + '-' + (entry.row.downline_cifid || entry.row.downline_name),
                        class: ["leaderboard-podium__slot", 'leaderboard-podium__slot--rank-' + entry.rank]
                      }, [
                        _createVNode("div", _hoisted_6, [
                          _createVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createVNode("img", {
                              src: _ctx.avatarFor(entry.row),
                              alt: entry.row.downline_name,
                              class: "leaderboard-podium__avatar",
                              onError: ($event: any) => (_ctx.onAvatarError(entry.row.downline_cifid))
                            }, null, 40, ["src", "alt", "onError"]),
                            _hoisted_9
                          ]),
                          _createVNode("div", _hoisted_10, _toDisplayString(entry.row.downline_name || "Group Member"), 1)
                        ]),
                        _createVNode("div", _hoisted_11, [
                          _createVNode("span", _hoisted_12, _toDisplayString(entry.rank), 1)
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.listRows.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listRows, (row, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: row.downline_cifid || index + 4,
                        class: "leaderboard-list__item seq-card"
                      }, [
                        _createVNode("div", _hoisted_14, _toDisplayString(index + 4), 1),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("img", {
                            src: _ctx.avatarFor(row),
                            alt: row.downline_name,
                            class: "leaderboard-list__avatar",
                            onError: ($event: any) => (_ctx.onAvatarError(row.downline_cifid))
                          }, null, 40, ["src", "alt", "onError"]),
                          _createVNode("div", _hoisted_16, _toDisplayString(row.downline_name || "Group Member"), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
  ]))
}